// -----------------------------------------------------------------------------
// 3) src/components/CommentList.jsx
// -----------------------------------------------------------------------------
import React from "react";
import { api } from "../lib/api";

export function CommentList({ target, objectId }) {
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const res = await api.getJson(`/engagement/comments?target=${target}&object_id=${objectId}`);
        if (!cancel) setItems(Array.isArray(res) ? res : res?.results || []);
      } catch (e) {
        console.warn("comments load failed", e);
      } finally { if (!cancel) setLoading(false); }
    })();
    return () => { cancel = true; };
  }, [target, objectId]);

  if (loading) return <div style={{ fontSize: 13, color: "#6b7280" }}>Loading comments…</div>;
  if (!items.length) return <div style={{ fontSize: 13, color: "#6b7280" }}>No comments yet.</div>;

  return (
    <div style={{ display: "grid", gap: 10 }}>
      {items.map(c => (
        <div key={c.id} style={{ padding: 10, border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff" }}>
          <div style={{ fontSize: 12, color: "#6b7280" }}>{new Date(c.created_at).toLocaleString()}</div>
          <div style={{ fontSize: 14, color: "#111827" }}>{c.text}</div>
        </div>
      ))}
    </div>
  );
}

